<template>
    <nav :class="{ active: isMenuMobileVisible }">
        <search-bar />
        <notes />
        <user-bar />
    </nav>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import Notes from "./menu/Notes";
    import SearchBar from "./menu/SearchBar";
    import UserBar from "./menu/UserBar";

    export default {
        name: "Menu",
        components: {
            Notes,
            SearchBar,
            UserBar
        },
        computed: {
            ...mapState("application", ["isMenuMobileVisible"])
        },

        // Window resize event system (we "destroy" the floating menu when possible)
        mounted: function() {
            this.$nextTick(function() {
                window.addEventListener("resize", this.hideIfTooLarge);
                this.hideIfTooLarge();
            }.bind(this));
        },
        methods: {
            hideIfTooLarge: function() {
                if (document.documentElement.clientWidth > 767) {
                    this.hideMenuMobile();
                }
            },
            ...mapMutations("application", ["hideMenuMobile"])
        },
        beforeDestroy: function() {
            window.removeEventListener("resize", this.hideIfTooLarge);
        }
    }
</script>

<style scoped>
    nav {
        position: absolute;
        background: #fff;
        top: 0;
        left: 0;
        height: 100%;
        width: 300px;
        border-right: 1px solid #e4eaec;
        z-index: 0;
        transition: all 0.5s ease-in-out;
        overflow: hidden !important;
    }

    @media screen and (max-width: 1100px) {
        nav {
            margin-left: -300px;
            z-index: 20;
        }
        nav.active {
            margin-left: 0px;
        }
    }
</style>